import { ICellRenderProps } from "./ICellRenderProps"
import { IRowRenderProps } from "./IRowRenderProps"
import * as React from 'react';
import { isNullOrEmpty } from "../common/util";
//used to render kendo grid cells as editable cell
export const CellRender = (props: ICellRenderProps) => {
    const dataItem = props.originalProps.dataItem;
    const cellField = props.originalProps.field || "";
    const keyboardCellRef = React.useRef<HTMLTableCellElement>(null);
    const isKeyboardEditing = props.keyboardEdit && dataItem.inEdit === cellField;

    React.useLayoutEffect(() => {
        if (!isKeyboardEditing) {
            return;
        }
        const input = keyboardCellRef.current?.querySelector("input");
        if (input) {
            if (props.editLabel) {
                input.setAttribute("aria-label", props.editLabel);
            }
            input.focus();
        }
    }, [isKeyboardEditing, props.editLabel]);

    if (props.keyboardEdit) {
        const enterKeyboardEdit = () => {
            if (!isKeyboardEditing) {
                props.enterEdit(dataItem, cellField);
            }
        };
        const keyboardProps = {
            ...props.td.props,
            ref: keyboardCellRef,
            // Once the editor opens, it replaces the cell as the single tab stop.
            tabIndex: isKeyboardEditing ? -1 : 0,
            onFocus: (event: React.FocusEvent<HTMLTableCellElement>) => {
                if (event.target === event.currentTarget) {
                    enterKeyboardEdit();
                }
            },
            onClick: enterKeyboardEdit,
            onKeyDown: (event: React.KeyboardEvent<HTMLTableCellElement>) => {
                if (event.target === event.currentTarget && (event.key === "Enter" || event.key === "F2")) {
                    event.preventDefault();
                    event.stopPropagation();
                    enterKeyboardEdit();
                }
            }
        };
        return React.cloneElement(props.td, keyboardProps, props.td.props.children);
    }

    const inEditField = dataItem[props.editField || ''];
    const additionalProps = cellField && cellField === inEditField ?
        {
            ref: (td: any) => {
                const input = td && td.querySelector('input');
                const activeElement = document.activeElement;

                if (!input ||
                    !activeElement ||
                    input === activeElement ||
                    !activeElement.contains(input)) {
                    return;
                }
                console.log(input);
                if (input.type === 'checkbox') {
                    input.focus();
                    input.title = "chktitle";
                } else {
                    input.select();
                }
            }
        } : {
            onClick: () => { props.enterEdit(dataItem, cellField); }
        };

    const clonedProps: any = { ...props.td.props, ...additionalProps };
    return React.cloneElement(props.td, clonedProps, props.td.props.children);
}
//used to render kendo grid row as editable 
export const RowRender = (props: IRowRenderProps) => {
    let hasInEdit = props.originalProps?.dataItem?.inEdit;
        const trProps = {
            ...props.tr.props,
            onBlur: (event: React.FocusEvent<HTMLTableRowElement>) => {
                const cell = event.target instanceof Element ? event.target.closest("td") : null;
                const focusRemainsInCell = event.relatedTarget instanceof Node && cell?.contains(event.relatedTarget);
                if (!isNullOrEmpty(hasInEdit) && !focusRemainsInCell) { props.exitEdit(); }
            }
        };
        return React.cloneElement(props.tr, { ...trProps }, props.tr.props.children);
}